<template>
  <div>
    <a href="javascript:void(0)" v-b-toggle="'collapse'" variant="primary" v-if="noteList.length > 0">Läs mer <i class="fa-angle-down fa"></i></a>
    <b-collapse :id="'collapse'" v-if="noteList.length > 0">
      <div class="note-list">
        <b>OBSERVERA</b>
        <div v-for="(note, index) in distinctNoteList" v-bind:key="index">
          <p><b>{{ note.name === '*' ? '*' : '&#9658;'}}</b> {{note.text}} </p>
        </div>
      </div>
    </b-collapse>
    <div v-for="ref in referenceList" v-bind:key="ref.id">
      <b-tooltip :target="ref.a_id" :title="ref.text"></b-tooltip>
    </div>
    <div v-for="note in noteList" v-bind:key="note.id">
      <b-tooltip :target="note.a_id" :title="note.text"></b-tooltip>
    </div>
  </div>
</template>

<script>
import { uniqBy } from 'lodash'

export default {
  name: 'RefrenceAndNoteList',
  model: {
    prop: 'text'
  },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      referenceList: [],
      noteList: []
    }
  },
  computed: {
    distinctNoteList () {
      return uniqBy(this.noteList, 'name')
    }
  },
  created () {
    var div = document.createElement('div')
    div.innerHTML = this.text

    let tags = div.getElementsByClassName('reference')
    for (let i = 0; i < tags.length; i++) {
      const reference = this.$store.getters.referenceByName(tags[i].text)
      if (reference) {
        this.referenceList.push({
          id: i + 1,
          a_id: 'ref-' + parseInt(i + 1) + reference.name,
          text: reference.text
        })
      }
    }

    let addedNotes = []
    let notes = div.getElementsByClassName('note')
    for (let i = 0; i < notes.length; i++) {
      const note = this.$store.getters.noteByName(notes[i].text)
      if (note && addedNotes.indexOf(note) === -1) {
        this.noteList.push({
          id: i + 1,
          a_id: 'note-' + parseInt(i + 1) + note.name,
          text: note.text,
          name: note.name
        })
        addedNotes.push(note)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .note-list {
    font-size: smaller;
    margin-top: 10px;
    background-color: $ljusgul;
    padding: 10px;
    border: 1px $grå50 solid;
  }
</style>


